import type { Router } from 'vue-router'
import { ElMessage } from 'element-plus'

// A deployed version can remove the lazy chunks still referenced by an open tab.
const RESOURCE_LOAD_ERROR = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i
const RECOVERY_KEY = 'hy:route-resource-recovery'

export function installRouteLoadRecovery(router: Router) {
  let recovering = false
  router.onError((error, to) => {
    if (recovering) return
    if (!RESOURCE_LOAD_ERROR.test(error.message)) {
      ElMessage.error('页面打开失败，请稍后重试')
      return
    }
    try {
      const now = Date.now()
      const previous = window.sessionStorage.getItem(RECOVERY_KEY)
      const elapsed = now - Number(previous)
      if (previous !== null && elapsed >= 0 && elapsed < 60_000) {
        ElMessage.error('页面资源加载失败，请检查网络后刷新重试')
        return
      }
      // Persist before navigating so another failed load cannot cause a reload loop.
      window.sessionStorage.setItem(RECOVERY_KEY, String(now))
      recovering = true
      window.location.assign(to.fullPath)
    } catch {
      recovering = false
      ElMessage.error('页面资源加载失败，请刷新后重试')
    }
  })
}
